import * as React from "react";
import {Link} from "react-router";
import {PokWalletAccounts} from "../../service/admin/WalletService";

interface Props {
    cubeiaId: number | string;
    accounts: PokWalletAccounts
}

export class AccountBalances extends React.Component<Props, {}> {

    getAccount(code: string, color: string) {
        return (
            <div className="col-sm-5 col-xs-12">
                <Link to={"/wallet/" + this.props.cubeiaId + "/" + code} type="button"
                      className={"btn btn-w-m btn-block btn-" + color}>
                    <div className="row vertical-align" style={{padding: "0.5em 0"}}>
                        <div className="col-xs-3">
                            <h3 style={{marginTop: "0"}} className="font-bold">{displayCurrencyCode(code)}</h3>
                        </div>
                        <div className="col-xs-9 text-right">
                            <h3 style={{marginTop: "0"}} className="font-bold">{this.props.accounts[code].walletBalance}</h3>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    render() {
        return (
            <div>
                <div className="col-sm-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            <h2>Account Balances</h2>
                            <h3>Main Accounts</h3>
                            <small>Balance used to buy in at tables and tournaments</small>
                            <div className="spacer"></div>
                            <div className="row">
                                {this.getAccount("gc-main", "primary")}
                                {this.getAccount("sc-main", "primary")}
                            </div>
                            <h3>Vault Accounts</h3>
                            <small>Balance accrued through Ring Game & Surge hands played</small>
                            <div className="spacer"></div>
                            <div className="row">
                            <div>
                                {this.getAccount("gc-vault", "primary")}
                                {this.getAccount("sc-vault", "primary")}
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function displayCurrencyCode(accountCode: string) {
    switch (accountCode) {
        case 'gc-main': return 'XGC';
        case 'sc-main': return 'XSD';
        case 'sc-vault': return 'VAULT-SC';
        case 'gc-vault': return 'VAULT-GC';
        default: return 'UNK';
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/user/AccountBalances.tsx